(function () {
  const root = document.querySelector('[data-ll-reviews]');
  if (!root) return;

  const list = root.querySelector('[data-ll-reviews-list]');
  const moreBtn = root.querySelector('[data-ll-reviews-more]');
  const sortSel = root.querySelector('[data-ll-reviews-sort]');
  const SHOW_STEP = 12;
  const PER_PAGE = 25;
  const SCAN_BUDGET = 20; /* max API pages fetched per user action */

  /* Judge.me public widget token (read-only, same one their widgets use). */
  const JM = {
    url: 'https://judge.me/api/v1/widgets/all_reviews_page.json',
    shopDomain: 'wearelittles.myshopify.com',
    token: '9LQ-NulTxDxjHLVsXNDFUmotjKQ',
  };

  const TYPE_CATS = {
    'Flavoured Instant Coffee': 'flavoured',
    'Decaf Flavoured Instant': 'decaf',
    'Nespresso® Compatible Capsules': 'capsules',
    'Premium Instant Coffee': 'classic',
    'Gifts & Merch': 'gifts',
    BYOB: 'flavoured',
  };

  let filter = 'all';
  let showCount = SHOW_STEP;
  let sortMode = 'newest';

  /* ---------- helpers ---------- */
  const starSvg = (off) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'currentColor');
    svg.setAttribute('focusable', 'false');
    if (off) svg.setAttribute('class', 'is-off');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute(
      'd',
      'M12 2.2l2.86 6.78 7.38.74-5.56 4.86 1.62 7.2L12 17.98 5.7 21.78l1.62-7.2L1.76 9.72l7.38-.74L12 2.2z'
    );
    svg.appendChild(path);
    return svg;
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const keywordCat = (text) => {
    const h = String(text || '').toLowerCase();
    if (h.includes('capsule')) return 'capsules';
    if (h.includes('decaf')) return 'decaf';
    if (h.includes('iced') || h.includes('concentrate')) return 'iced';
    if (
      h.includes('gift') ||
      h.includes('bundle') ||
      h.includes('advent') ||
      h.includes('hamper') ||
      h.includes('starter set')
    )
      return 'gifts';
    if (h.includes('colombian') || h.includes('premium') || h.includes('all-day') || h.includes('all day'))
      return 'classic';
    return 'flavoured';
  };

  /* handle -> category, learned from the store's own product types */
  const handleCat = {};
  const learnProducts = () =>
    fetch('/products.json?limit=250')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!data || !data.products) return;
        data.products.forEach((p) => {
          handleCat[p.handle] = TYPE_CATS[p.product_type] || keywordCat(p.handle + ' ' + p.title);
        });
        fillProductPicker(data.products);
        live.reviews.forEach((item) => {
          item.cat = catFor(item);
        });
        if (live.active) renderLive();
      })
      .catch(() => {});

  function catFor(item) {
    if (!item.handle) return 'shop';
    return handleCat[item.handle] || keywordCat(item.handle + ' ' + item.productTitle);
  }

  /* ---------- card rendering (textContent only) ---------- */
  const buildCard = (item) => {
    const card = document.createElement('article');
    card.className = 'll-reviews__card';
    card.dataset.cat = item.cat;

    const top = document.createElement('div');
    top.className = 'll-reviews__card-top';
    const stars = document.createElement('span');
    stars.className = 'll-reviews__stars';
    stars.setAttribute('aria-hidden', 'true');
    for (let i = 1; i <= 5; i += 1) stars.appendChild(starSvg(i > (item.rating || 5)));
    top.appendChild(stars);
    const time = document.createElement('time');
    time.textContent = item.dateText || '';
    top.appendChild(time);
    card.appendChild(top);

    if (item.title) {
      const h = document.createElement('h3');
      h.textContent = item.title;
      card.appendChild(h);
    }
    if (item.body) {
      const p = document.createElement('p');
      p.textContent = item.body;
      card.appendChild(p);
    }

    const footer = document.createElement('footer');
    const author = document.createElement('span');
    author.textContent = item.author || 'Anonymous';
    footer.appendChild(author);
    if (item.verified) {
      const v = document.createElement('span');
      v.className = 'll-reviews__verified-by';
      v.textContent = 'Verified buyer';
      footer.appendChild(v);
    }
    if (item.productTitle) {
      if (item.productUrl) {
        const a = document.createElement('a');
        a.href = item.productUrl;
        a.textContent = item.productTitle;
        footer.appendChild(a);
      } else {
        const s = document.createElement('span');
        s.textContent = item.productTitle;
        footer.appendChild(s);
      }
    }
    card.appendChild(footer);
    return card;
  };

  /* ---------- live Judge.me data ---------- */
  const live = {
    active: false,
    reviews: [],
    page: 0,
    totalPages: 1,
    loading: false,
    headerDone: false,
    gen: 0,
  };

  const jmUrl = (page) => {
    const params = new URLSearchParams({
      platform: 'shopify',
      shop_domain: JM.shopDomain,
      api_token: JM.token,
      page: String(page),
      per_page: String(PER_PAGE),
      sort_by: 'most_recent',
      sort_dir: sortMode === 'oldest' ? 'asc' : 'desc',
      json_request: 'true',
      review_type: 'all-reviews',
      review_source: 'all_sources',
      add_header_counts: 'true',
    });
    return `${JM.url}?${params.toString()}`;
  };

  const mapReview = (r) => {
    const url = r.product_url || '';
    const handle = url ? url.split('/products/')[1] || '' : '';
    const item = {
      rating: r.rating || 5,
      title: (r.title || '').trim(),
      body: (r.body || '').trim(),
      author: r.reviewer_name || 'Anonymous',
      verified: Boolean(r.verified_buyer),
      dateText: formatDate(r.created_at),
      productTitle: r.is_shop_review ? '' : r.product_title || '',
      productUrl: r.is_shop_review ? '' : url,
      handle: r.is_shop_review ? '' : handle.split('?')[0],
      cat: 'flavoured',
    };
    item.cat = catFor(item);
    return item;
  };

  const updateHeader = (data) => {
    if (live.headerDone || !data) return;
    live.headerDone = true;
    const total = data.number_of_reviews;
    const avg = parseFloat(data.average_rating);
    const hist = data.rating_histogram_data || [];

    const strongs = root.querySelectorAll('.ll-reviews__summary strong');
    if (strongs[0] && avg) strongs[0].textContent = `${String(avg).replace(/\.?0+$/, '')}/5`;
    if (strongs[1] && total) strongs[1].textContent = total.toLocaleString('en-GB');

    const showing = root.querySelector('.ll-reviews__showing');
    if (showing && total)
      showing.textContent = `Showing the latest from ${total.toLocaleString('en-GB')} reviews`;

    const max = Math.max(...hist.map((h) => h.frequency || 0), 1);
    const lis = root.querySelectorAll('.ll-reviews__bars li');
    hist.forEach((h) => {
      const li = lis[5 - h.rating];
      if (!li) return;
      const count = li.querySelector('.ll-reviews__bar-count');
      if (count) count.textContent = h.frequency;
      const fill = li.querySelector('.ll-reviews__bar span');
      if (fill) fill.style.width = `${Math.round(((h.frequency || 0) / max) * 100)}%`;
    });

    const five = hist.find((h) => h.rating === 5);
    const asideH = root.querySelector('.ll-reviews__aside h2');
    if (five && asideH) asideH.textContent = `${five.percentage}% gave us five stars`;
  };

  const fetchNextPage = () => {
    if (live.loading || live.page >= live.totalPages) return Promise.resolve(false);
    live.loading = true;
    const next = live.page + 1;
    const gen = live.gen;
    return fetch(jmUrl(next))
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('jm'))))
      .then((data) => {
        live.loading = false;
        if (gen !== live.gen) return false; /* sort changed mid-flight, drop */
        live.page = next;
        live.totalPages = data.total_pages || next;
        updateHeader(data);
        (data.reviews || []).forEach((r) => live.reviews.push(mapReview(r)));
        if (live.active) renderLive();
        return true;
      })
      .catch(() => {
        live.loading = false;
        return false;
      });
  };

  const countFor = (cat) =>
    cat === 'all' ? live.reviews.length : live.reviews.filter((i) => i.cat === cat).length;

  /* Fetch until the current filter has enough, or pages run out (bounded).
     Waits out any in-flight fetch (e.g. sort switched mid-scan). */
  const ensure = (needed) => {
    let budget = SCAN_BUDGET;
    const step = () => {
      if (countFor(filter) >= needed || live.page >= live.totalPages || budget <= 0) {
        return Promise.resolve();
      }
      if (live.loading) {
        return new Promise((res) => setTimeout(res, 250)).then(step);
      }
      budget -= 1;
      return fetchNextPage().then((ok) => (ok ? step() : undefined));
    };
    return step();
  };

  const renderLive = () => {
    const items =
      filter === 'all' ? live.reviews : live.reviews.filter((i) => i.cat === filter);
    list.replaceChildren();
    items.slice(0, showCount).forEach((item) => list.appendChild(buildCard(item)));
    if (!items.length && !live.loading) {
      const empty = document.createElement('p');
      empty.className = 'll-reviews__empty';
      empty.textContent = 'No reviews in this category yet.';
      list.appendChild(empty);
    }
    if (moreBtn) {
      moreBtn.hidden = !(items.length > showCount || live.page < live.totalPages);
      moreBtn.disabled = live.loading;
      moreBtn.textContent = live.loading ? 'Loading…' : 'Load more reviews';
    }
  };

  /* ---------- seeded fallback (server-rendered blocks) ---------- */
  const seededCards = [...list.querySelectorAll('[data-ll-review]')];
  const legacyApply = () => {
    let matched = 0;
    seededCards.forEach((card) => {
      const ok = filter === 'all' || card.dataset.cat === filter;
      if (!ok) {
        card.hidden = true;
        return;
      }
      matched += 1;
      card.hidden = showCount < matched;
    });
    if (moreBtn) {
      moreBtn.hidden = matched <= showCount;
      moreBtn.disabled = false;
      moreBtn.textContent = 'Load more reviews';
    }
  };

  const apply = () => {
    if (live.active) {
      renderLive();
      ensure(showCount).then(renderLive);
    } else {
      legacyApply();
    }
  };

  /* ---------- events ---------- */
  root.addEventListener('click', (event) => {
    const filterBtn = event.target.closest('[data-ll-reviews-filter]');
    if (filterBtn) {
      filter = filterBtn.dataset.llReviewsFilter;
      showCount = SHOW_STEP;
      root.querySelectorAll('[data-ll-reviews-filter]').forEach((btn) => {
        btn.classList.toggle('is-on', btn === filterBtn);
      });
      apply();
    }
    if (event.target.closest('[data-ll-reviews-more]')) {
      showCount += SHOW_STEP;
      apply();
    }
  });

  if (sortSel) {
    sortSel.addEventListener('change', () => {
      sortMode = sortSel.value === 'oldest' ? 'oldest' : 'newest';
      showCount = SHOW_STEP;
      if (live.active) {
        /* Refetch in the other direction */
        live.gen += 1;
        live.reviews = [];
        live.page = 0;
        live.totalPages = 1;
        apply();
      } else {
        const ordered =
          sortMode === 'oldest' ? seededCards.slice().reverse() : seededCards;
        ordered.forEach((card) => list.appendChild(card));
        legacyApply();
      }
    });
  }

  /* ---------- write-a-review modal (Judge.me form, same as PDP) ---------- */
  const modal = root.querySelector('[data-ll-review-modal]');
  const writeBtn = root.querySelector('[data-ll-write-review]');
  const productSelect = root.querySelector('[data-ll-review-product]');
  const host = root.querySelector('[data-ll-review-host]');
  const fallbackNote = root.querySelector('[data-ll-review-fallback]');

  const fillProductPicker = (products) => {
    if (!productSelect) return;
    const sorted = products.slice().sort((a, b) => a.title.localeCompare(b.title));
    sorted.forEach((p) => {
      const opt = document.createElement('option');
      opt.value = String(p.id);
      opt.textContent = p.title;
      productSelect.appendChild(opt);
    });
  };

  const waitFor = (test, timeout) =>
    new Promise((resolve) => {
      const started = Date.now();
      const tick = () => {
        if (test()) return resolve(true);
        if (Date.now() - started > timeout) return resolve(false);
        setTimeout(tick, 200);
      };
      tick();
    });

  const buildReviewForm = (productId) => {
    if (!host) return;
    host.replaceChildren();
    if (fallbackNote) fallbackNote.hidden = true;

    const loading = document.createElement('p');
    loading.className = 'll-review-modal__hint';
    loading.textContent = 'Loading the review form…';
    host.appendChild(loading);

    const widget = document.createElement('div');
    widget.className = 'jdgm-widget jdgm-review-widget';
    widget.setAttribute('data-id', productId);
    host.appendChild(widget);

    const tryInit = () => {
      const jdgm = window.jdgm;
      if (typeof jdgm.loadCSS === 'function' && typeof jdgm.widgetPath === 'function') {
        try {
          jdgm.loadCSS(jdgm.widgetPath('form.css'));
        } catch (e) {
          /* form.css is best-effort */
        }
      }
      /* The gallery helper ships in a script this page never loads. */
      if (typeof jdgm.setupMediaGallery !== 'function') jdgm.setupMediaGallery = function () {};
      try {
        jdgm.initializeWidgets(jdgm.$(host));
      } catch (e) {
        /* Judge.me scripts may still be loading; the retry below covers it. */
      }
    };
    const widgetDone = () => widget.classList.contains('jdgm--done-setup-widget');

    waitFor(
      () =>
        window.jdgm &&
        typeof window.jdgm.initializeWidgets === 'function' &&
        typeof window.jdgm._renderAndSetupReviewForm === 'function',
      12000
    )
      .then((ready) => {
        if (!ready) throw new Error('jdgm unavailable');
        tryInit();
        return waitFor(widgetDone, 5000);
      })
      .then((done) => {
        if (done) return true;
        tryInit();
        return waitFor(widgetDone, 6000);
      })
      .then((done) => {
        if (!done) throw new Error('widget setup failed');
        return waitFor(() => host.querySelector('.jdgm-write-rev-link'), 6000);
      })
      .then((found) => {
        if (!found) throw new Error('write link missing');
        host.querySelector('.jdgm-write-rev-link').click();
        return waitFor(() => host.querySelector('form.jdgm-form'), 6000);
      })
      .then((found) => {
        loading.remove();
        if (!found) throw new Error('form missing');
      })
      .catch(() => {
        loading.remove();
        if (fallbackNote) fallbackNote.hidden = false;
      });
  };

  if (modal && writeBtn && productSelect && host) {
    const openModal = () => {
      modal.hidden = false;
      document.body.classList.add('ll-review-modal-open');
      productSelect.focus({ preventScroll: true });
    };
    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('ll-review-modal-open');
      writeBtn.focus({ preventScroll: true });
    };

    writeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-ll-review-modal-close]')) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
    productSelect.addEventListener('change', () => {
      if (productSelect.value) buildReviewForm(productSelect.value);
    });
  }

  /* ---------- boot ---------- */
  legacyApply();
  learnProducts();
  fetchNextPage().then((ok) => {
    if (ok && live.reviews.length) {
      live.active = true;
      apply();
    }
  });
})();
